import { useMutation } from "@tanstack/react-query";
import { useCartContext } from "app/providers/CartProvider";
import { useSearchParams } from "react-router-dom";
import { api } from "shared/api";
import { STORAGE_ORDER_KEY, STORAGE_PAYMENT_URL } from "shared/config";
import { toast } from "react-toastify";
import { decryptVoucher } from "shared/utils/voucher";
import {
  CheckoutTabIds,
  useCheckoutTabsContext,
} from "pages/checkout/providers/CheckoutTabsProvider";

export const useCheckoutRequestAsync = () => {
  const cartContext = useCartContext();
  const cart = cartContext.getCart();
  const [searchParams, setSearchParams] = useSearchParams();
  const { updateCurrentTab } = useCheckoutTabsContext();

  const canCheckout = () => {
    if (
      cart.products.length > 0 ||
      cart.supplyProducts.length > 0 ||
      cart.standardProducts.length > 0
    ) {
      return true;
    }
    return false;
  };

  const checkout = async () => {
    if (!canCheckout()) {
      toast.error("Er is iets foutgegaan bij het plaatsen van uw order");
      return;
    }

    // Decrypt the discount code back to original string
    const newCart = { ...cart };

    // Decrypt the discount code back to original string
    newCart.discountCode = decryptVoucher(cart.discountCode);

    // Set the payment details for standard products to null, so no payment link is created in the middleware
    newCart.standardProductPayment = {
      paymentBank: 0,
      paymentMethod: 0,
      paymentType: "",
    };

    const res = await api().checkout(newCart, { method: "POST" });
    return res.data;
  };

  const mutation = useMutation(checkout, {
    onSuccess: (data) => {
      if (!data) {
        toast.error("Er is iets foutgegaan bij het plaatsen van uw order");
        return;
      }

      const { nextStep, paymentUrl, isSampleSale, orderId } = data;

      localStorage.setItem(STORAGE_ORDER_KEY, orderId);
      localStorage.setItem(STORAGE_PAYMENT_URL, paymentUrl);

      if (nextStep === "appointment") {
        searchParams.set("reference", data.orderId);
        searchParams.set("type", isSampleSale ? "shipment" : "measurement");
        setSearchParams(searchParams);
      } else if (nextStep === "redirect" && paymentUrl) {
        window.location.href = paymentUrl;
      } else if (nextStep === "empty") {
        updateCurrentTab(CheckoutTabIds.CALENDAR);
      }
    },
    onError: () => {
      toast.error("Er is iets foutgegaan bij het plaatsen van uw order");
    },
  });

  const handleCheckout = async () => {
    try {
      await mutation.mutateAsync(); // Use async/await here
    } catch (error) {
      // Handle error
      toast.error("Er is iets foutgegaan bij het plaatsen van uw order");
    }
  };

  return {
    handleCheckout,
    isLoading: mutation.isLoading,
  };
};
